import { createApp } from 'vue'
import '@/assets/style/resset.css'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from '@/router/index.js'
import { createPinia } from 'pinia'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

const pinia = createPinia()
const app = createApp(App)
app.use(ElementPlus,{
    locale: zhCn,
}).use(router)
app.use(pinia)
app.mount('#app')
